/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {BarbarianFuryGameConfig} from "../BarbarianFuryGameConfig";

export class BarbarianFuryReelSymbolStateCreator extends ReelSymbolStateCreator {
    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const symName:string = symbol.symName.split("*")[0];

        if((stateKey === BarbarianFuryGameConfig.instance.SYMBOL_STATES.idle.keyword && BarbarianFuryGameConfig.instance.SYMBOLS_WITH_IDLE_SPINE.indexOf(symName) !== -1) ||
            (stateKey === BarbarianFuryGameConfig.instance.SYMBOL_STATES.initialWin.keyword && BarbarianFuryGameConfig.instance.SYMBOLS_WITH_WIN_SPINE.indexOf(symName) !== -1)) {
            const spineTextures:PIXI.spine.core.SkeletonData = GameResources.getSpineAsset(symName + "_spine");
            const spine:PIXI.spine.Spine = new PIXI.spine.Spine(spineTextures);

            if(stateConfig.offsetGetter) {
                let offset = stateConfig.offsetGetter(symName, stateKey);
                let index:number = (symbol.stackedSymName) ? symbol.stackedSymName!.index : 0;
                if(symbol.stackedSymName!.isStacked) {
                    spine.position.set(offset[0], ((BarbarianFuryGameConfig.instance.SYMBOLS_NUM_PER_REEL - index) * BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT) - offset[1]);
                } else {
                    spine.position.set(offset[0], offset[1]);
                }
            }

            return (spine as any);
        }
        return super.getBasicStateAnimation(symbol, stateKey, stateConfig);
    }
}